<template>
  <div class="my-table userAssignmentPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('userAssignment.txt1')}}</span>
        <span>{{$t('userAssignment.txt2')}} / {{$t('userAssignment.txt3')}} / {{$t('userAssignment.txt4')}}</span>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('userAssignment.txt4')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('userAssignment.txt5')}}</div>
          <div class="searchBtn" @click="confirmUserDistribution">{{$t('userAssignment.txt6')}}</div>
        </div>
      </div>
      <div class="editForm userAssignmentEdit">
        <div class="flexStart">
          <span class="cellTitle">{{$t('userAssignment.txt7')}} {{distributionParams.desktopName}}</span>
          <div class="handleBoxSeach flexCenter w350">
            <el-input :placeholder="$t('userAssignment.txt8')" v-model="name" @keypress.native.enter="loadData"></el-input>
            <div class="searchBtn" @click="getAllUser">{{$t('userAssignment.txt9')}}</div>
          </div>
        </div>
        <div class="transferBox">
          <el-row class="elTransferTitle" :gutter="70">
            <el-col :span="12">{{$t('userAssignment.txt10')}}</el-col>
            <el-col :span="12">{{$t('userAssignment.txt11')}}</el-col>
          </el-row>
          <el-transfer :titles="[$t('userAssignment.txt12'), $t('userAssignment.txt12')]" v-model="checkedList" :props="transferProps" :data="userList">
          </el-transfer>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      const generateData = _ => {
        const userList = [];
        for (let i = 1; i <= userList.length; i++) {
          userList.push({
            key: userList[i].value,
            label: userList[i].label,
          });
        }
        return userList;
      };
      return {
        distributionParams:{},
        checkedList: [],//穿梭框数组
        transferProps: {
          key: 'value',
          label: 'label'
        },
        name:'',
        userInfoArr:[],
        userList: generateData(),//所有用户
      };
    },
    created() {
      let row = JSON.parse(decodeURIComponent(this.$route.query.row));
      if(row){
        let list = row.userInfos;
        this.checkedList = [];
        if(list){
          list.map(e=>{
            this.checkedList.push(e.id);
          })
        }
        this.distributionParams = {
          id:row.id,
          desktopName:row.desktopName,
          lanIp:row.lanIp,
          wanIp:row.wanIp,
          desktopPort:row.desktopPort,
          desktopUrl:row.desktopUrl,
          desktopDescribe:row.desktopDescribe,
          userInfos:[],
          online:row.online,
          state: row.state,
        };
      }
      
      this.getAllUser();
    },
    methods: {
      onBack(){
        this.$router.go(-1);
      },
      // 获取所有用户
      async getAllUser() {
        let data = {
          name:this.name
        }
        const {data: res} = await this.$http.post("/user/info/list/all?"+ qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        let list = res.result;
        this.userList = [];
        this.userInfoArr = [];
        list.map(e=>{
          let item = {
            value:e.id,
            label:e.userName
          }
          this.userInfoArr.push(e);
          this.userList.push(item);
        })
      },
      // 分配用户名
      confirmUserDistribution(){
        let list  = this.userInfoArr;
        let arr = [];
        list.map(e=>{
          this.checkedList.map(i=>{
            if(i == e.id){
              let item = e;
              arr.push(item);
            }
          })
        })
        this.distributionParams.userInfos = arr;
        this.add(this.distributionParams);
      },
      // 节点管理添加/修改
      async add(params){
        let userInfos = [];
        params.userInfos.map(e=>{
          userInfos.push(e);
        })
        let data = params;
        data.userInfos = userInfos;
        let wanIp = params.wanIp?params.wanIp:'--';
        let desktopUrl = params.desktopPort?params.desktopPort:'300';
        data.desktopUrl = 'https://'+wanIp+':'+desktopUrl+'/main/home';
        const { data: res } = await this.$http.post("/desktop/add",data);
        if(res.success){
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.$router.go(-1);
        }else{
          return this.$message.error(res.message);
        }
        
      },
    },
  };
</script>

<style lang="less" scoped>
  .userAssignmentPage{
    .contactTitle{
      margin-bottom: 40px;
    }
    .handleBoxSeach{
      background-color: #F4F4F4;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .userAssignmentEdit{
      width: 840px;
      display: block;
      margin: 7.2rem auto 0 auto;
    }
    .transferBox{
      .elTransferTitle{
        padding:3.1rem 0 2.1rem 0;
        font-size: 14px;
        font-weight: 500;
        color: #222222;
      }
      /deep/ .el-transfer{
        display: flex;
        justify-content: center;
        .el-transfer-panel{
          background: #F4F4F4;
          border-radius: 18px;
          overflow: hidden;
          border: none;
        }
        .el-transfer-panel__header{
          background: #DFE2E8;
          .el-checkbox__label{
            font-weight: 500;
            color: #1B3B7C;
            font-size: 14px;
          }
        }
        .el-transfer__buttons{
          display: flex;
          justify-content: center;
          align-content: center;
          padding: 0 !important;
          .el-transfer__button{
            padding: 0 !important;
            width: auto;
            height: auto;
            background: #fff;
            border: none;
            margin: 0;
          }
          .el-button+.el-button{
            margin: 0;
          }
        }
      }
    }
    
  }

</style>
